import { useState, useEffect } from 'react';

const useGeoLocation = () => {
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
    error: null,
  });

  useEffect(() => {
    const successHandler = (position) => {
      console.log('Success:', position);
      setLocation({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        error: null,
      });
    };
    
    const errorHandler = (error) => {
      console.log('Error:', error);
      setLocation({
        latitude: null,
        longitude: null,
        error: error.message || 'Geolocation error',
      });
    };

    // Check if geolocation is supported
    if (navigator.geolocation) {
      // Get the current position
      navigator.geolocation.getCurrentPosition(successHandler, errorHandler);
    } else {
      console.log('Geolocation is not supported');
      setLocation({
        latitude: null,
        longitude: null,
        error: 'Geolocation is not supported',
      });
    }
  }, []); // Empty dependency array means this effect runs once after the initial render

  return location;
};

export default useGeoLocation;
